import axios from 'axios';

async function ObtenerSocioDocumento(prm_Documento: string) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_socio"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "documento": prm_Documento
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerSocioDocumento;